import Http from "./base-http";

class TaskSkill extends Http {
  addTaskSkill(variables) {
    return this.create(variables);
  }
  deleteTaskSkill(id) {
    return this.destroy(id);
  }
}
const taskSkill = new TaskSkill({
  modelUrlPrefix : "TaskSkill"
});
export default taskSkill;